const staticPageUrlPrefix = '/page/';

export const getIsStaticPage = path => path.startsWith(staticPageUrlPrefix);
export const getStaticPageName = path => path.replace(staticPageUrlPrefix, '');

export const setOGTag = (name, content) => {
  let item = document.querySelector(`meta[property='og:${name}']`);

  if (!content) {
    if (item) {
      document.head.removeChild(item);
    }
    return;
  }

  if (item == null) {
    item = document.createElement('meta');
    item.setAttribute('property', `og:${name}`);
    item.content = content;
    document.head.appendChild(item);
  } else {
    item.content = content;
  }
};

export const getCurrentPage = (pageList, pathname, search) => {
  if (getIsStaticPage(pathname)) {
    const staticPageName = getStaticPageName(pathname);
    const currentPageIndex = pageList.findIndex(sPage => sPage.slug === staticPageName);

    return { currentPage: pageList[currentPageIndex] || null, currentPageIndex };
  }

  /*
    matchLength is needed to make match more precise
    For example:
    for page https://yesbet.com/Football/England/CopaDelRey?e=1724424
    page with "/Football/England/CopaDelRey" slug has higher priority then "/Footbal
  */
  let specificMatchPageIndex = -1;
  let specificMatchLength = 0;
  let groupMatchPageIndex = -1;
  let groupMatchLength = 0;

  for (let i = 0; i < pageList.length; i += 1) {
    const page = pageList[i];
    const slug = decodeURIComponent(page.slug);

    if (
      // If page is related to search and search includes page slug
      search &&
      ((slug.startsWith('?') && search.includes(slug.slice(1, slug.length))) ||
        `${pathname}${search}`.endsWith(slug))
    ) {
      return { currentPage: page, currentPageIndex: i };
    }

    if (
      // handling slug for specific page
      slug.startsWith('/') &&
      pathname.endsWith(slug) &&
      slug.length > specificMatchLength
    ) {
      specificMatchPageIndex = i;
      specificMatchLength = slug.length;
    } else if (
      // If page slug ends with '/' and path includes slug then current path matches page
      slug.endsWith('/') &&
      pathname.includes(slug.slice(0, slug.length - 1)) &&
      slug.length > groupMatchLength
    ) {
      groupMatchPageIndex = i;
      groupMatchLength = slug.length;
    }
  }

  const currentPageIndex =
    specificMatchPageIndex === -1 ? groupMatchPageIndex : specificMatchPageIndex;

  return {
    currentPage: pageList[currentPageIndex] || null,
    currentPageIndex,
  };
};
